// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/RebateSubtitleCampaign.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h853M3gAg2GvK7OqcCk2 {
  font-size: var(--campaign-prize-fund-font-desktop);
}
.h853M3gAg2GvK7OqcCk2[data-has-many='true'] {
  font-size: var(--campaign-prize-fund-font-has-many);
}
.h853M3gAg2GvK7OqcCk2[data-has-many='true'][data-collapsed='true'] {
  font-size: var(--campaign-prize-fund-font-has-many-collapsed);
}
.h853M3gAg2GvK7OqcCk2[data-collapsed='true'] {
  font-size: var(--campaign-prize-fund-font-collapsed);
}
.HD7dl_ud3mZ8DF6Z97t8 {
}
.Gn9lQJhElcl38XB0bV7G {
}
.h853M3gAg2GvK7OqcCk2[data-has-many='true'][data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
  text-shadow: var(--campaign-rebate-subtitle-text-shadow-has-many-collapsed);
}
.WbBRDgAzEXWPp8DYao3Q {
}
.Yq92zxvbiioCuZz39KpA {
}
.CeEF2JPfR6EIGlWHZbuN {
  font-size: var(--campaign-prize-fund-currency-desktop);
  margin-left: 3px;
}
.CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] {
  font-size: var(--campaign-prize-currency-collapsed-desktop);
}
.CeEF2JPfR6EIGlWHZbuN[data-has-many='true'][data-collapsed='true'] {
  align-self: center;
}
.CeEF2JPfR6EIGlWHZbuN[data-has-many='true'][data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--campaign-prize-fund-currency-has-many-collapsed);
  line-height: 0.85;
  vertical-align: baseline;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .h853M3gAg2GvK7OqcCk2 {
    font-size: var(--campaign-prize-fund-font-mobile);
  }
  .h853M3gAg2GvK7OqcCk2[data-has-many='true'] {
    font-size: var(--campaign-prize-fund-font-has-many-mobile);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-mobile);
  }
  .h853M3gAg2GvK7OqcCk2[data-has-many='true'][data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN {
    font-size: var(--campaign-prize-fund-currency-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] {
    font-size: var(--campaign-prize-currency-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-has-many='true'][data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
    font-size: var(--campaign-prize-currency-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'][data-has-many='false'] .Gn9lQJhElcl38XB0bV7G {
    vertical-align: bottom;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .h853M3gAg2GvK7OqcCk2 {
    font-size: var(--campaign-prize-fund-font-portrait);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G,
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='true'] .Gn9lQJhElcl38XB0bV7G {
    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN {
    font-size: var(--campaign-prize-fund-currency-portrait);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
    height: 100%;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 0.85;
    vertical-align: baseline;
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'][data-has-many='false'] {
    margin-top: 0;
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='false'] .CeEF2JPfR6EIGlWHZbuN {
    align-self: center;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .h853M3gAg2GvK7OqcCk2 {
    font-size: var(--campaign-prize-fund-font-portrait);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G,
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='true'] .Gn9lQJhElcl38XB0bV7G {
    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN {
    font-size: var(--campaign-prize-fund-currency-portrait);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
    height: 100%;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 0.85;
    vertical-align: baseline;
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'][data-has-many='false'] {
    margin-top: 0;
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='false'] .CeEF2JPfR6EIGlWHZbuN {
    align-self: center;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .h853M3gAg2GvK7OqcCk2 {
    font-size: var(--campaign-prize-fund-font-landscape);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-landscape);
  }
  .h853M3gAg2GvK7OqcCk2[data-has-many='true'][data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-mobile);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='true'] .Gn9lQJhElcl38XB0bV7G {
    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN {
    font-size: var(--campaign-prize-fund-currency-landscape);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] {
    font-size: var(--campaign-prize-currency-collapsed-landscape);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-has-many='true'][data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
    font-size: var(--campaign-prize-currency-collapsed-mobile);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .h853M3gAg2GvK7OqcCk2 {
    font-size: var(--campaign-prize-fund-font-landscape);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-landscape);
  }
  .h853M3gAg2GvK7OqcCk2[data-has-many='true'][data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-mobile);
  }
  .h853M3gAg2GvK7OqcCk2[data-collapsed='true'][data-has-many='true'] .Gn9lQJhElcl38XB0bV7G {
    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);
  }
  .CeEF2JPfR6EIGlWHZbuN {
    font-size: var(--campaign-prize-fund-currency-landscape);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-collapsed='true'] {
    font-size: var(--campaign-prize-currency-collapsed-landscape);
  }
  .CeEF2JPfR6EIGlWHZbuN[data-has-many='true'][data-collapsed='true'] .Gn9lQJhElcl38XB0bV7G {
    font-size: var(--campaign-prize-currency-collapsed-mobile);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/shared/RebateSubtitleCampaign/css/SingleViewRebateSubtitleCampaign.module.css"],"names":[],"mappings":"AAAA;EAEE,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,oDAAoD;AACtD;AACA;AAEA;AACA;AAEA;AACA;EACE,2EAA2E;AAC7E;AACA;AAEA;AACA;AAEA;AACA;EAEE,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE;IACE,iDAAiD;EACnD;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,qDAAqD;EACvD;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,sBAAsB;EACxB;AACF;AACA;AAAA;EACE;IACE,mDAAmD;EACrD;EACA;;IAEE,yEAAyE;EAC3E;EACA;IACE,uDAAuD;EACzD;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;AAAA;AA1BA;AAAA;AAAA;AAAA;EACE;IACE,mDAAmD;EACrD;EACA;;IAEE,yEAAyE;EAC3E;EACA;IACE,uDAAuD;EACzD;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,8DAA8D;EAChE;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,0DAA0D;EAC5D;AACF;AAAA;AAtBA;AAAA;AAAA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,8DAA8D;EAChE;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,0DAA0D;EAC5D;AACF;AAAA;AAAA;AAAA","sourcesContent":[".subtitleContainer {\n  composes: subtitleContainer from './base/RebateSubtitleCampaign.base.module.css';\n  font-size: var(--campaign-prize-fund-font-desktop);\n}\n.subtitleContainer[data-has-many='true'] {\n  font-size: var(--campaign-prize-fund-font-has-many);\n}\n.subtitleContainer[data-has-many='true'][data-collapsed='true'] {\n  font-size: var(--campaign-prize-fund-font-has-many-collapsed);\n}\n.subtitleContainer[data-collapsed='true'] {\n  font-size: var(--campaign-prize-fund-font-collapsed);\n}\n.subtitleTextWrapper {\n  composes: subtitleTextWrapper from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleTextStyle {\n  composes: subtitleTextStyle from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleContainer[data-has-many='true'][data-collapsed='true'] .subtitleTextStyle {\n  text-shadow: var(--campaign-rebate-subtitle-text-shadow-has-many-collapsed);\n}\n.subtitleTextStyleMain {\n  composes: subtitleTextStyleMain from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleTextStylePrefix {\n  composes: subtitleTextStylePrefix from './base/RebateSubtitleCampaign.base.module.css';\n}\n.currency {\n  composes: currency from './base/RebateSubtitleCampaign.base.module.css';\n  font-size: var(--campaign-prize-fund-currency-desktop);\n  margin-left: 3px;\n}\n.currency[data-collapsed='true'] {\n  font-size: var(--campaign-prize-currency-collapsed-desktop);\n}\n.currency[data-has-many='true'][data-collapsed='true'] {\n  align-self: center;\n}\n.currency[data-has-many='true'][data-collapsed='true'] .subtitleTextStyle {\n  height: 100%;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--campaign-prize-fund-currency-has-many-collapsed);\n  line-height: 0.85;\n  vertical-align: baseline;\n}\n@media (--campaign-mobile) {\n  .subtitleContainer {\n    font-size: var(--campaign-prize-fund-font-mobile);\n  }\n  .subtitleContainer[data-has-many='true'] {\n    font-size: var(--campaign-prize-fund-font-has-many-mobile);\n  }\n  .subtitleContainer[data-collapsed='true'] {\n    font-size: var(--campaign-prize-fund-font-collapsed-mobile);\n  }\n  .subtitleContainer[data-has-many='true'][data-collapsed='true'] {\n    font-size: var(--campaign-prize-fund-font-collapsed-mobile);\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-mobile);\n  }\n  .currency[data-collapsed='true'] {\n    font-size: var(--campaign-prize-currency-collapsed-mobile);\n  }\n  .currency[data-has-many='true'][data-collapsed='true'] .subtitleTextStyle {\n    font-size: var(--campaign-prize-currency-collapsed-mobile);\n  }\n  .currency[data-collapsed='true'][data-has-many='false'] .subtitleTextStyle {\n    vertical-align: bottom;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .subtitleContainer {\n    font-size: var(--campaign-prize-fund-font-portrait);\n  }\n  .subtitleContainer[data-collapsed='true'] .subtitleTextStyle,\n  .subtitleContainer[data-collapsed='true'][data-has-many='true'] .subtitleTextStyle {\n    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-portrait);\n  }\n  .currency[data-collapsed='true'] .subtitleTextStyle {\n    height: 100%;\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    line-height: 0.85;\n    vertical-align: baseline;\n  }\n  .currency[data-collapsed='true'][data-has-many='false'] {\n    margin-top: 0;\n  }\n  .subtitleContainer[data-collapsed='true'][data-has-many='false'] .currency {\n    align-self: center;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .subtitleContainer {\n    font-size: var(--campaign-prize-fund-font-landscape);\n  }\n  .subtitleContainer[data-collapsed='true'] {\n    font-size: var(--campaign-prize-fund-font-collapsed-landscape);\n  }\n  .subtitleContainer[data-has-many='true'][data-collapsed='true'] {\n    font-size: var(--campaign-prize-fund-font-collapsed-mobile);\n  }\n  .subtitleContainer[data-collapsed='true'][data-has-many='true'] .subtitleTextStyle {\n    text-shadow: var(--campaign-rebate-subtitle-text-shadow-collapsed-mobile);\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-landscape);\n  }\n  .currency[data-collapsed='true'] {\n    font-size: var(--campaign-prize-currency-collapsed-landscape);\n  }\n  .currency[data-has-many='true'][data-collapsed='true'] .subtitleTextStyle {\n    font-size: var(--campaign-prize-currency-collapsed-mobile);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitleContainer": `h853M3gAg2GvK7OqcCk2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleContainer"]}`,
	"subtitleTextWrapper": `HD7dl_ud3mZ8DF6Z97t8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextWrapper"]}`,
	"subtitleTextStyle": `Gn9lQJhElcl38XB0bV7G ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStyle"]}`,
	"subtitleTextStyleMain": `WbBRDgAzEXWPp8DYao3Q ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStyleMain"]}`,
	"subtitleTextStylePrefix": `Yq92zxvbiioCuZz39KpA ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStylePrefix"]}`,
	"currency": `CeEF2JPfR6EIGlWHZbuN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["currency"]}`
};
export default ___CSS_LOADER_EXPORT___;
